export default __webpack_public_path__ + "css/adminServices.bundle.css";